import { showNotification } from "@mantine/notifications";

const success = (message: string) => {
  showNotification({
    color: "green",
    title: "Хүсэлт амжилттай!",
    message,
  });
};

const error = (message: string) => {
  showNotification({
    color: "red",
    title: "Хүсэлт амжилтгүй!",
    message,
  });
};

export const message = {
  success,
  error,
};
